import { getFirestore, collection, getDocs } from "firebase/firestore";
import { useState, useEffect, useId, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { PageHeader, SectionHeader } from "@/components/ui/page-header";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import { VISAVALUE } from "../types/visa.type";

export const VisaList = () => {
  const [selectedVisa, setSelectedVisa] = useState<string>("");
  const selectId = useId();
  const db = getFirestore();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchVisaTypes = async () => {
      const visaQuestionsRef = collection(db, "visa_questions");
      const querySnapshot = await getDocs(visaQuestionsRef);
      const visas = querySnapshot.docs.map((doc) => doc.id);
    };

    fetchVisaTypes();
  }, [db]);

  const EXCLUDED_VISAS: VISAVALUE[] = [VISAVALUE.EMPTY, VISAVALUE.EB2NIW];

  const displayVisas = useMemo(
    () =>
      Object.values(VISAVALUE).filter(
        (v) => v !== "" && !EXCLUDED_VISAS.includes(v as VISAVALUE)
      ) as string[],
    []
  );

  const handleEditVisa = () => {
    if (selectedVisa) {
      navigate(`/admin/visa-questionnaire-builder/${selectedVisa}`);
    }
  };

  return (
    <div className="h-full overflow-y-auto bg-surface">
      <div className="mx-auto flex w-full max-w-190 flex-col gap-8 px-12 pt-10 pb-24">
        <PageHeader
          title="Visa Questionnaire Management"
          description="Select a visa type to modify its questionnaire questions."
        />

        <section className="flex flex-col gap-3">
          <SectionHeader
            title="Visa Type"
            description={
              displayVisas.length > 0
                ? `Available visa types: ${displayVisas.join(", ")}`
                : undefined
            }
          />
          <div className="flex flex-col gap-4 rounded-lg bg-elevated p-4 ring-1 ring-line-2">
            <div className="flex flex-col gap-1.5">
              <Label htmlFor={selectId}>Select Visa Type</Label>
              <Select
                value={selectedVisa || undefined}
                onValueChange={setSelectedVisa}
              >
                <SelectTrigger id={selectId} className="w-full">
                  <SelectValue placeholder="Choose a visa type to edit..." />
                </SelectTrigger>
                <SelectContent>
                  {displayVisas.map((visa) => (
                    <SelectItem key={visa} value={visa}>
                      {visa.toUpperCase()}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="flex justify-end">
              <Button
                variant="primary"
                size="sm"
                disabled={!selectedVisa}
                onClick={handleEditVisa}
              >
                Edit Questions
              </Button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};
